import { Outlet } from 'react-router-dom';
import AuthModal from '../common/AuthModal';
import CartDrawer from '../cart/CartDrawer';
import Navbar from './Navbar';

export default function AppLayout() {
  return (
    <div className="app-frame">
      <Navbar />
      <AuthModal />
      <CartDrawer />
      <main className="page-shell">
        <Outlet />
      </main>
    </div>
  );
}